/**
 * SessionQrCode - Renders a QR code for a session join URL
 *
 * Displays a scannable QR code with a white background wrapper
 * for reliable scanning on any theme. Returns null when URL is empty.
 */

import { QRCodeSVG } from 'qrcode.react';

interface SessionQrCodeProps {
  /** Fully-qualified join URL, e.g. https://host/?code=ABCD */
  url: string;
  /** Pixel size for the SVG. Defaults to 200. */
  size?: number;
}

const QR_SIZE_DEFAULT = 200;

/**
 * Render a centred QR code SVG that encodes the join URL
 *
 * @param props - Component props
 * @returns QR code element or null when url is empty
 */
export function SessionQrCode({ url, size = QR_SIZE_DEFAULT }: SessionQrCodeProps) {
  if (!url) return null;

  return (
    <div className="flex flex-col items-center gap-2 pt-2">
      <div className="rounded-lg bg-white p-3 shadow-sm">
        <QRCodeSVG value={url} size={size} />
      </div>
      <p className="text-xs text-muted-foreground text-center">
        Scan to join this session
      </p>
    </div>
  );
}
